import { LoadingOutlined } from "@ant-design/icons";
import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import { Spin } from "antd";
import AppApi from "api/App/AppApi";
import React, { useEffect, useState } from "react";
import AceEditor from "react-ace";
import { LOGSTYPE } from "utils/Constants/Constants";
import { normalizeLogItem } from "utils/format/NormalLog";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 42,
      color: "var(--mk-p-color)",
    }}
    spin
  />
);

function getTypeText(type: number) {
  const typeObj = LOGSTYPE.find(
    (item: any) => item.value === type || item.key === type,
  );
  return typeObj ? typeObj.label : "N/A";
}

interface LogDetailProps {
  info: any;
}

const LogDetail: React.FC<LogDetailProps> = ({ info }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<any>(null);

  const detailLog = async (info: any) => {
    try {
      setLoading(true);
      const response = await AppApi.checkLog(info?.id);

      if (response?.code === 0) {
        let data: any = response?.data;
        let items: any[] = data?.items || [];

        const transformedItems = items.map((item) => {
          const normalized = normalizeLogItem(item);
          return {
            ...normalized,
            type: getTypeText(normalized.type),
          };
        });

        setData(transformedItems);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    detailLog(info);
  }, [info]);

  return (
    <>
      {loading ? (
        <div style={{ textAlign: "center", padding: 20 }}>
          <Spin
            spinning={loading}
            indicator={antIcon}
            tip={
              <span style={{ color: "var(--mk-p-color)" }}>Đang tải...</span>
            }
            size="large"
          />
        </div>
      ) : (
        <AceEditor
          mode="json"
          theme="github"
          name="editor"
          editorProps={{ $blockScrolling: true }}
          fontSize={14}
          width="100%"
          height="70vh"
          style={{ marginTop: 2, marginBottom: 5 }}
          value={data ? JSON.stringify(data, null, 2) : "Chưa có dữ liệu"}
          readOnly={true}
        />
      )}
    </>
  );
};

export default LogDetail;
